import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CmsEffects } from './store/cms.effects';
import { cmsReducer } from './store/cms.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('cms', cmsReducer),
    EffectsModule.forFeature([CmsEffects]),
  ],
})
export class CmsModule {}
